import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { BRAND_TAGLINE, BRAND_SLOGAN } from "../constants";
import { BRAND_COLOR_GRADIENT_ONE, BRAND_COLOR_GRADIENT_TWO } from "../constants";

const HeroSection = () => {

  const navigate = useNavigate();

  const handleJoinNow = () => {
    navigate("/timetable"); // 👈 navigates to the timetable page
  };


  return (
    <section
      style={{
        textAlign: "center",
        padding: "100px 20px",
        background: `linear-gradient(to right, ${BRAND_COLOR_GRADIENT_ONE}, ${BRAND_COLOR_GRADIENT_TWO})`,
        color: "white",
      }}
    >
      <motion.h1
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        style={{ fontSize: "3rem", fontWeight: "bold" }}
      >
         {BRAND_TAGLINE}
      </motion.h1>

      <p style={{ fontSize: "1.2rem", marginTop: "20px" }}>
        {BRAND_SLOGAN}
      </p>

      
      {/* <button

        onClick={handleJoinNow}
        style={{
          marginTop: "30px",
          padding: "15px 30px",
          backgroundColor: "white",
          color: "#007BFF",
          border: "none",
          borderRadius: "30px",
          fontWeight: "bold",
          cursor: "pointer",
        }}
      >
        Join Now
      </button>*/}
      
    </section>
  );
};

export default HeroSection;
